import React from "react";
import { FileText, Image as ImageIcon } from "lucide-react";

import Button from "../../../componentsv2/Button";
import {
  arquivoEhImagem,
  normalizarArquivoPrescricao,
} from "../utils/prescricaoArquivos";

export default function PrescricoesAgendamento({
  prescricoes = [],
  loading = false,
  emptyText = "Nenhuma prescrição anexada",
  onPreview,
  onDownload,
  onRemove,
}) {
  if (loading) {
    return (
      <p style={{ margin: 0, fontSize: "14px", color: "#999999" }}>
        Carregando prescrições...
      </p>
    );
  }

  if (!prescricoes.length) {
    return (
      <div
        style={{
          border: "1px dashed #CFD8DC",
          borderRadius: "10px",
          minHeight: "120px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "14px",
        }}
      >
        <FileText size={36} strokeWidth={1.25} color="#B0BEC5" />
        <span style={{ fontSize: "14px", color: "#999999" }}>{emptyText}</span>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {prescricoes.map((prescricao, index) => {
        const arquivo = normalizarArquivoPrescricao(prescricao);
        const IconeArquivo = arquivoEhImagem(arquivo) ? ImageIcon : FileText;

        return (
          <div
            key={arquivo.id || `${arquivo.nomeOriginal}-${arquivo.size}-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              padding: "14px 16px",
              border: "1px solid #ECEFF1",
              borderRadius: "8px",
              backgroundColor: "#FAFAFA",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
              <IconeArquivo size={20} strokeWidth={1.5} color="#78909C" style={{ flexShrink: 0 }} />
              <span
                title={arquivo.nomeOriginal}
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#333344",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {arquivo.nomeOriginal}
              </span>
            </div>

            <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
              {onPreview && (
                <Button type="button" variant="outlined" onClick={() => onPreview(prescricao)}>
                  Visualizar
                </Button>
              )}
              {onDownload && (
                <Button type="button" variant="outlined" onClick={() => onDownload(prescricao)}>
                  Baixar
                </Button>
              )}
              {onRemove && (
                <Button
                  type="button"
                  color="red"
                  variant="outlined"
                  onClick={() => onRemove(prescricao)}
                >
                  Remover
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
